import React, { Component } from 'react';
import { connect } from 'react-redux';

import InputSimples from '../../components/Inputs/Simples';
import Voltar from '../../components/Links/Voltar';
import Loading from '../../components/Loading';
import { verifyAdmin } from '../../utils/verify-admin';
import * as actions from '../../actions/usuariosAdmin';

const EMAIL_PODE_DEFINIR_DEVELOPER = 'giovaniw2@gmail.com';

function podeDefinirDeveloper(admin) {
	return admin && String(admin.email || '').toLowerCase() === EMAIL_PODE_DEFINIR_DEVELOPER;
}

const TODAS_PERMISSOES = [
	{ valor: 'admin', label: 'Administrador (pedidos, catálogo, entregas…)' },
	{ valor: 'mkt', label: 'Marketing (clientes, e-mail, Google)' },
	{ valor: 'owner', label: 'Proprietário (configurações e usuários)' },
	{ valor: 'scanner', label: 'Leitor de QR (somente atribuir lote pela tela do link/etiqueta)' },
	{ valor: 'developer', label: 'Desenvolvedor (ferramentas técnicas)' }
];

class FormularioUsuario extends Component {

	state = {
		nome: '',
		email: '',
		password: '',
		permissao: { admin: false, mkt: false, owner: false, scanner: false, developer: false },
		saving: false,
		listaUsuarios: []
	}

	componentDidMount(){
		const { admin } = this.props;
		if(admin && verifyAdmin(admin, 'owner')){
			this.props.getUsuariosAdmin().then((data) => {
				if(this._ehErroLista(data)) return;
				const lista = data.usuarios || [];
				this.setState({ listaUsuarios: lista }, () => this.hidratar(lista));
			});
		}else{
			this.hidratar([]);
		}
	}

	componentDidUpdate(prevProps){
		if(prevProps.match.params.id !== this.props.match.params.id && this.props.admin && verifyAdmin(this.props.admin, 'owner')){
			this.props.getUsuariosAdmin().then((data) => {
				if(this._ehErroLista(data)) return;
				const lista = data.usuarios || [];
				this.setState({ listaUsuarios: lista }, () => this.hidratar(lista));
			});
		}
	}

	_ehErroLista = (data) => {
		if(!data) return true;
		if(data.status && data.message){
			window.alert(data.message);
			return true;
		}
		if(data.errors){
			window.alert(typeof data.errors === 'string' ? data.errors : 'Erro ao carregar usuários.');
			return true;
		}
		return false;
	}

	_ehErro = (data) => {
		if(!data) return true;
		if(data.status && data.message){
			window.alert(data.message);
			return true;
		}
		if(data.errors){
			window.alert(typeof data.errors === 'string' ? data.errors : 'Erro ao processar.');
			return true;
		}
		return false;
	}

	hidratar = (lista) => {
		const id = this.props.match.params.id;
		if(!id){
			this.setState({
				nome: '',
				email: '',
				password: '',
				permissao: { admin: true, mkt: false, owner: false, scanner: false, developer: false }
			});
			return;
		}
		const row = (lista || []).find((u) => u && String(u._id) === String(id));
		if(!row){
			window.alert('Usuário não encontrado.');
			this.props.history.push('/usuarios');
			return;
		}
		const perm = { admin: false, mkt: false, owner: false, scanner: false, developer: false };
		(row.permissao || []).forEach((p) => {
			if(p in perm) perm[p] = true;
		});
		this.setState({
			nome: row.nome || '',
			email: row.email || '',
			password: '',
			permissao: perm
		});
	}

	montarPermissaoArray = () => {
		const { permissao } = this.state;
		const { admin, match } = this.props;
		const arr = [];
		if(permissao.admin) arr.push('admin');
		if(permissao.mkt) arr.push('mkt');
		if(permissao.owner) arr.push('owner');
		if(permissao.scanner) arr.push('scanner');
		if(podeDefinirDeveloper(admin)) {
			if(permissao.developer) arr.push('developer');
		} else {
			const editId = match.params.id;
			if(editId) {
				const row = (this.state.listaUsuarios || []).find((u) => u && String(u._id) === String(editId));
				if(row && (row.permissao || []).includes('developer')) arr.push('developer');
			}
		}
		return arr;
	}

	onTogglePermissao = (valor) => {
		if(valor === 'owner' && this.ownerTravadoPorSerUnico()){
			return;
		}
		this.setState((prev) => ({
			permissao: { ...prev.permissao, [valor]: !prev.permissao[valor] }
		}));
	}

	ownerTravadoPorSerUnico = () => {
		const { listaUsuarios, permissao } = this.state;
		const editId = this.props.match.params.id;
		if(!editId || !permissao.owner) return false;
		const qtdOwners = (listaUsuarios || []).filter((u) => (u.permissao || []).includes('owner')).length;
		return qtdOwners === 1;
	}

	salvar = () => {
		const { nome, email, password, saving } = this.state;
		const { admin, match, history } = this.props;
		if(saving) return;
		if(!admin || !verifyAdmin(admin, 'owner')) return;

		const permissao = this.montarPermissaoArray();
		if(!nome.trim() || !email.trim()){
			window.alert('Preencha nome e e-mail.');
			return;
		}
		if(permissao.length === 0){
			window.alert('Selecione ao menos uma permissão.');
			return;
		}

		const editId = match.params.id;
		if(!editId && !password){
			window.alert('Defina uma senha para o novo usuário.');
			return;
		}

		this.setState({ saving: true });
		const done = () => this.setState({ saving: false });

		if(editId){
			const body = { nome: nome.trim(), email: email.trim(), permissao };
			if(password) body.password = password;
			this.props.putUsuarioAdmin(editId, body).then((data) => {
				done();
				if(this._ehErro(data)) return;
				history.push('/usuarios');
			});
		}else{
			this.props.postUsuarioAdmin({
				nome: nome.trim(),
				email: email.trim(),
				password,
				permissao
			}).then((data) => {
				done();
				if(this._ehErro(data)) return;
				history.push('/usuarios');
			});
		}
	}

	render(){
		const { admin } = this.props;
		const { nome, email, password, permissao, saving } = this.state;
		const editId = this.props.match.params.id;

		if(!admin) return <Loading />;

		if(!verifyAdmin(admin, 'owner')){
			return null;
		}

		const travarOwner = this.ownerTravadoPorSerUnico();
		const labelBotao = saving ? 'Salvando…' : (editId ? 'Salvar alterações' : 'Adicionar');
		const permissoesUi = TODAS_PERMISSOES.filter(
			(p) => p.valor !== 'developer' || podeDefinirDeveloper(admin)
		);

		return (
			<div className="Category container-centered UsuariosForm">
				<div className="head">
					<Voltar path="/usuarios" />
					<h1>{editId ? 'Editar usuário' : 'Novo usuário'}</h1>
				</div>

				<div className="items">
					<div className="form">
						<div className="double">
							<InputSimples label="Nome:" name="nome" value={nome} onChange={(ev) => this.setState({ nome: ev.target.value })} />
							<InputSimples label="E-mail:" name="email" value={email} onChange={(ev) => this.setState({ email: ev.target.value })} />
						</div>
						<InputSimples
							type="password"
							label={editId ? 'Nova senha (deixe em branco para manter):' : 'Senha:'}
							name="password"
							value={password}
							onChange={(ev) => this.setState({ password: ev.target.value })}
						/>
					</div>

					<div className="usuario-form-permissoes">
						<span className="usuario-form-label">Permissões</span>
						{permissoesUi.map((p) => (
							<label key={p.valor} className={`entregadoresNovo-checkAtivo usuario-form-check${p.valor === 'owner' && travarOwner ? ' usuario-form-check--disabled' : ''}`}>
								<input
									type="checkbox"
									checked={!!permissao[p.valor]}
									disabled={p.valor === 'owner' && travarOwner}
									onChange={() => this.onTogglePermissao(p.valor)}
								/>
								<span>{p.label}{p.valor === 'owner' && travarOwner ? ' — não pode ser removida enquanto for o único proprietário da loja.' : ''}</span>
							</label>
						))}
					</div>

					<div className="ButtonSubmit">
						<button type="button" onClick={this.salvar} disabled={saving}>{labelBotao}</button>
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => ({
	admin: state.auth.usuario
});

export default connect(mapStateToProps, actions)(FormularioUsuario);
